'use client';

import { useEffect } from 'react';
import { inject } from '@vercel/analytics';

/**
 * Client component that ensures analytics is properly initialized
 * This component should be included in the app layout
 */
export default function AnalyticsInitializer() {
  useEffect(() => {
    // Initialize Vercel Analytics
    try {
      inject();
      
      // Create a fallback window.va if needed
      if (!window.va) {
        console.warn('Creating fallback Vercel Analytics implementation');
        
        // Create basic va function
        // @ts-ignore - We're creating our own implementation
        window.va = function(event: string, properties?: any) {
          if (process.env.NODE_ENV === 'development') {
            console.log(`[Analytics] ${event}`, properties);
          }
        };
        
        // Add track method for backwards compatibility
        // @ts-ignore - Adding track method
        window.va.track = function(eventName: string, properties?: any) {
          if (window.va) {
            // Call the main function with proper params
            window.va('event', { name: eventName, ...properties });
          }
        };
      } else if (typeof window.va === 'function' && typeof (window.va as any).track !== 'function') {
        // If va exists but doesn't have track method, add it
        // @ts-ignore - Adding track method
        window.va.track = function(eventName: string, properties?: any) {
          if (window.va) {
            // Call the main function with proper params
            window.va('event', { name: eventName, ...properties });
          }
        };
      }
      
      console.log('Vercel Analytics initialized successfully');
    } catch (error) {
      console.error('Failed to initialize Vercel Analytics:', error);
    }
  }, []);

  // This component doesn't render anything
  return null;
} 